import { PROJECT_INSTRUCTIONS, SESSION_PROMPTS } from './prompts';

// Two kinds of resources:
//   - kind: 'download'  → external link / file the user opens or saves
//   - kind: 'copy'      → in-app prompt the user can read and copy to clipboard
//
// `tag` is the small pill at the top-left of each card.

export const RESOURCES = [
  {
    id: 'campus-map',
    tag: 'Venue',
    title: 'SCUHS Campus Map',
    description:
      'Drive in off Amber Valley Drive through Lot 4, then park in Lot 2 or 3. Sessions are in Room M-71 (M Building, back of campus). The Glen — between the trees, marked red on the map — is where the Thursday Student Meet & Greet lunch happens.',
    url: '/resources/scuhs-campus-map.png',
    kind: 'download',
    sort: -1,
  },
  {
    id: 'checklist',
    tag: 'Before You Arrive',
    title: 'Pre-Conference Preparation Checklist',
    description:
      'Fill out the sections before you arrive. Covers association basics, membership, governance, advocacy and the files to bring on your laptop for Session Zero.',
    url: '/resources/ELX_2026_Pre_Event_Checklist.docx',
    kind: 'download',
    sort: 0,
  },
  {
    id: 'prompts-master',
    tag: 'Reference',
    title: 'Session Prompts (full document)',
    description:
      'The complete ELX 2026 Project Instructions + every session-opening prompt in one document. Each individual prompt is also available below.',
    url: '/resources/ELX_2026_Session_Prompts.docx',
    kind: 'download',
    sort: 1,
  },
  {
    id: 'project-instructions',
    tag: 'Session 0',
    title: 'Project Instructions',
    description:
      'Paste this once into the Project Instructions field when you set up your ELX 2026 AI project during Session Zero.',
    text: PROJECT_INSTRUCTIONS,
    kind: 'copy',
    sort: 10,
  },
  {
    id: 's1-prompt',
    tag: 'Session 1',
    title: 'Succession Planning — Opening Prompt',
    description:
      'Paste this into a new conversation inside your ELX 2026 project to begin Session 1.',
    text: SESSION_PROMPTS.s1,
    kind: 'copy',
    sort: 20,
  },
  {
    id: 's2-prompt',
    tag: 'Session 2',
    title: 'Governance & Leadership Pipeline — Opening Prompt',
    description:
      'Paste this into a new conversation inside your ELX 2026 project to begin Session 2.',
    text: SESSION_PROMPTS.s2,
    kind: 'copy',
    sort: 30,
  },
  {
    id: 's3-prompt',
    tag: 'Session 3',
    title: 'Membership — Opening Prompt',
    description:
      'Paste this into a new conversation inside your ELX 2026 project to begin Session 3.',
    text: SESSION_PROMPTS.s3,
    kind: 'copy',
    sort: 40,
  },
  {
    id: 's4-prompt',
    tag: 'Session 4',
    title: 'Communication Strategy — Opening Prompt',
    description:
      'Paste this into a new conversation inside your ELX 2026 project to begin Session 4.',
    text: SESSION_PROMPTS.s4,
    kind: 'copy',
    sort: 50,
  },
  {
    id: 's5-prompt',
    tag: 'Session 5',
    title: 'Revenue Diversification — Opening Prompt',
    description:
      'Paste this into a new conversation inside your ELX 2026 project to begin Session 5.',
    text: SESSION_PROMPTS.s5,
    kind: 'copy',
    sort: 60,
  },
];
